import Result from "@/core/common/Result";
import { IDesativarVoucherUseCase } from "../ports/DesativarVoucherUseCase";
import { inject, injectable } from "inversify";
import {
  type IDesativarVoucherGateway,
  desativarVoucherGatewayDI
} from "../ports/DesativarVoucherGateway";
import "reflect-metadata";

@injectable()
export class DesativarVoucherUseCaseAdapter
  implements IDesativarVoucherUseCase
{
  @inject(desativarVoucherGatewayDI)
  gateway!: IDesativarVoucherGateway;

  async desativarVoucher(id: string): Promise<Result<void>> {
    const response = await this.gateway.desativarVoucher(id);

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
